import PageBreadcrumbs from "@/components/PageBreadcrumbs";
import { companyContactOptions, useCompanyContact } from "@/api";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { REAL_ESTATE, WELCOME_ACCESS_URL } from "@/lib";
import i18n from "@/i18n/config";
import { capitalizeFirstLetter } from "@/lib";
import { useWelcomeAccessAccess } from "@/hooks/useWelcomeAccessAccess";
import { Suspense, useEffect } from "react";
import { useLoggedInUser, useRouterStore } from "@/store/zustandStore";
import AccessCardsWithAccessControlSystemIntegrated from "@/components/access_cards/AccessCardsWithAccessControlSystemIntegrated";
import { AcsConnectivityBanner } from "@/components/AcsConnectivityBanner";

export const Route = createFileRoute("/_portal/access")({
  component: Access,
  loader: () => {
    const { queryClient, user } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(companyContactOptions(user.buildingTenantId));
  },
});

function Access() {
  const { t } = useTranslation();
  const user = useLoggedInUser();
  const { data: companyContact } = useCompanyContact(user.buildingTenantId);
  const navigate = useNavigate();
  const { companyAccessControlSystemIntegrated } = useWelcomeAccessAccess(
    true,
    user.buildingTenantId,
  );
  const hasAccess =
    companyAccessControlSystemIntegrated &&
    !!user.integratedWithAccessControlSystem;

  // Send users without access to their default landing page instead of showing an empty page
  useEffect(() => {
    if (!hasAccess) navigate({ to: "/", replace: true });
  }, [hasAccess, navigate]);

  return (
    <>
      <PageBreadcrumbs
        levels={[{ label: t("PAGES.ACCESS.HEADER"), path: "/access" }]}
      />
      <AcsConnectivityBanner />
      <div className="pageHeader">
        <h1>{t("PAGES.ACCESS.HEADER")}</h1>
        <p>
          <Trans
            i18nKey="PAGES.ACCESS.SUBHEADER"
            values={{
              building: capitalizeFirstLetter(REAL_ESTATE),
            }}
          >
            Text
            <a href={WELCOME_ACCESS_URL(i18n.language)} target="_blank"></a>
            Text
          </Trans>

          {companyContact && (
            <strong>
              {" "}
              <Trans
                i18nKey="YOUR_MAIN_ADMIN"
                values={{
                  companyContact: companyContact.name,
                }}
                components={{
                  mailto: <a href={`mailto:${companyContact.email}`}></a>,
                }}
              ></Trans>
            </strong>
          )}
        </p>
      </div>
      <Suspense>
        {hasAccess ? (
          <AccessCardsWithAccessControlSystemIntegrated user={user} />
        ) : null}
      </Suspense>
    </>
  );
}
